
import lang from 'element-ui/lib/locale/lang/ar' // 引入element语言包
const messages = {
  message: {

  },
  ...lang,
}

export default messages
